export const getSchedule = (state, division) => state.scheduleReducer[division];

export const getMatchById = (state, matchId) => {
  for (let division = 1; division <= 3; division++) {
    const schedule = state.scheduleReducer[division];
    if (schedule) {
      const match = schedule.matches[matchId];
      if (match) {
        return match;
      }
    }
  }
  return null;
};

export const getDivisionByMatchId = (state, matchId) => {
  for (let division = 1; division <= 3; division++) {
    if (state.scheduleReducer[division].matches[matchId]) {
      return division;
    }
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/store/schedule/scheduleSelectors.js